// ══════════════════════════════════════════════════════
//  extractors/protocolFundamentals.js — 协议基本面
//
//  源：Artemis Metrics（hyperliquid_native 或 paid Artemis API）
//      + TokenFutures（CoinGlass 资金费率 / OI / 多空比）
// ══════════════════════════════════════════════════════

import { safeNum, pick } from './_shared';

export function isAvailable(project) {
  return !!project?.artemisMetrics?.ok || !!project?.tokenFutures;
}

export function extract(project /* , a */) {
  const am = project?.artemisMetrics;
  const tf = project?.tokenFutures;
  if (!am?.ok && !tf) return null;

  const data = {
    artemisOK: !!am?.ok,
    source: am?.source === 'hyperliquid_native' ? 'Hyperliquid · DefiLlama' : 'Artemis',

    // 现货 / 永续活跃度
    perpVolume24h:  safeNum(am?.perpVolume24h),
    totalOI:        safeNum(am?.totalOI),
    activeMarkets:  safeNum(am?.activeMarkets),
    perpFees24h:    safeNum(am?.perpFees24h),
    perpFees7d:     safeNum(am?.perpFees7d),
    perpFees30d:    safeNum(am?.perpFees30d),
    revenue24h:     safeNum(am?.revenue24h),
    revenue7d:      safeNum(am?.revenue7d),
    revenue30d:     safeNum(am?.revenue30d),
    stakedHype:     safeNum(am?.stakedHype),
    perpDauLatest:  safeNum(am?.perpDauLatest),
    perpDau30d:     safeNum(am?.perpDau30d),

    // Top 8 永续市场
    topAssets: Array.isArray(am?.topAssets) ? am.topAssets.slice(0, 8) : [],

    // 期货信号
    fundingRate:    safeNum(tf?.fundingRate),
    openInterest:   safeNum(tf?.openInterest),
    longShortRatio: safeNum(tf?.longShortRatio),
    futuresSource:  tf ? 'CoinGlass' : null,

    // 协议分成率（rev/fees）
    revFeeRate: (safeNum(am?.revenue30d) && safeNum(am?.perpFees30d))
      ? safeNum(am.revenue30d) / safeNum(am.perpFees30d) : null,
  };

  return data;
}
